module.exports = __webpack_public_path__ + "img/Step2.516a936b.png";